import { useContext } from "react";

import { ParticipantsContextMenuContext } from "./ParticipantsContextMenuContext";

export function useParticipantsContextMenu() {
  const context = useContext(ParticipantsContextMenuContext);
  if (!context) {
    throw new Error("useParticipantsContextMenu must be used within a ParticipantsContextMenuProvider");
  }
  return context;
}
